import Home from "../pages/servers/Home";
import Order from "../pages/servers/Order";
import CashPayment from "../pages/servers/CashPayment";

const ServerRoutes = [
  { path: '/servers', element: <Home />, exact: true },
  { path: '/servers/home', element: <Home />, exact: true },
  { path: '/servers/orders', element: <Order />, exact: true },
  { path: '/servers/payment', element: <CashPayment />, exact: true },
];

export default ServerRoutes;